import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { ListNavigationModule, SpinnerModule } from '@spartacus/storefront';

import { KnBrCustomerSearchResultComponent } from './kn-br-customer-search-result.component';
import { KnBrCustomPipesModule } from 'src/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [KnBrCustomerSearchResultComponent],
  imports: [
    CommonModule,
    I18nModule,
    SpinnerModule,
    ListNavigationModule,
    KnBrCustomPipesModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrPurchasingAgentSearchResultComponent: {
          component: () =>
            import('./kn-br-customer-search-result.component').then((c) => c.KnBrCustomerSearchResultComponent),
        },
      },
      pagination: {
        addStart: true,
        addEnd: true,
        addFirst: true,
        addLast: true,
      },
    } as CmsConfig),
  ],
  exports: [KnBrCustomerSearchResultComponent],
})
export class KnBrCustomerSearchResultModule {}
